import request from '../utils/request'
import QS from 'qs'

export function getCompanyReport (data) {
  return request({
    url: '/api/company-report/profile',
    method: 'get',
    params:data,
  })
}

export function companyEdit (id,data) {
  return request({
    url: `/api/company-report/${id}`,
    method: 'put',
    data:QS.stringify(data),
  })
}
export function companyReportPost (data) {
  return request({
    url: '/api/company-report',
    method: 'post',
    data:QS.stringify(data),
  })
}
export function guZhenTrademarkAuth (data) {
  return request({
    url: '/api/company-report/trademark_auth',
    method: 'post',
    data:QS.stringify(data),
  })
}
